export default {
    flex: {
        DEFAULT_VALUE: '--'
    }
}
